import { useState } from 'react';

const useCustomHook = () => {
  const [data, setData] = useState({
    bizs: [],
    guilds: [],
    products: [],
  });
  const [loading, setLoading] = useState(false);

  return {
    loading,
    setLoading,
    data,
    setData,
  };
};

export default useCustomHook;
